module.exports = __webpack_public_path__ + "img/img10.3820c9bb.png";